import { Maybe } from "util/maybe";

export type Nullable<T> = T | null;

export function nullableToMaybe<T>(t: Nullable<T>): Maybe<T> {
    return t === null ? undefined : t;
}
